// extracted by mini-css-extract-plugin
module.exports = {"suggestedDishList":"_29Upia9JCqIuez-XYe0Epf","externalId":"_1IqitAjsmL2tPpX-8ReTqk"};